import React, { useEffect, useState } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { Edit, Trash2 } from "react-feather";
import AddPackages from "./AdminComp/AddPackages";
import { baseurl, imageUrl } from "../../component/Baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


function AdminPackages() {
  const [packages, setPackages] = useState([]); // State to store package data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null); // Store package for editing
  const [showModal, setShowModal] = useState(false); // Control modal visibility

  // Fetch Packages from API
  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseurl}/GetAllPackages`); // Update API URL if needed
      if (response.data && response.data.packages) {
        setPackages(response.data.packages);
      }
    } catch (err) {
      setError("Failed to fetch packages");
      console.error("Error fetching packages:", err);
    } finally {
      setLoading(false);
    }
  };

  // Handle Delete Package
  const deletePackage = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}DeletePackageById/${id}`);
          setPackages(packages.filter((pkg) => pkg.id !== id)); // Remove from UI
          
          Swal.fire({
            title: "Deleted!",
            text: "The package has been deleted.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        } catch (err) {
          console.error("Error deleting package:", err);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete the package.",
            icon: "error",
          });
        }
      }
    });
  };


  const navigate = useNavigate(); 
  // Handle Edit Package
const editPackage = (id) => {
    Swal.fire({
      title: "Edit Package?",
      text: "Do you want to edit this package?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/edit-package/${id}`); // Navigate to edit page on confirmation
      }
    });
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">All Packages</h2>
                  <div className="ms-auto">
                     <AddPackages/>
                  </div>
                </div>

                {/* Loading and Error Handling */}
                {loading && (
                  <div className="d-flex justify-content-center align-items-center vh-100 text-white">
                    <span className="loader1">
                      <span className="text-white"></span>
                    </span>
                  </div>
                )}
                {error && <p className="text-danger">No Packages Available</p>}

                {/* Table */}
                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Image</th>
                              <th>Package Name</th>
                              <th>Price</th>
                              <th>Date Added</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {packages.map((pkg, index) => (
                              <tr key={pkg.id}>
                                <td>{index + 1}</td>
                                <td>
                                  <img
                                    src={
                                      pkg.banner_image
                                        ? `${imageUrl}packages/${pkg.banner_image}`
                                        : "https://via.placeholder.com/50" // Placeholder if no image
                                    }
                                    alt={pkg.package_name}
                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                  />
                                </td>
                                <td>
                                  {pkg.package_name}
                                  <div className="ftq1">{pkg.package_description}</div>
                                </td>
                                <td>&#8377;{pkg.price}</td>
                                <td>{new Date(pkg.created_at).toLocaleDateString()}</td>
                                <td>
                                  <span className="btn2 me-2" title="Edit" onClick={() => editPackage(pkg.id)}>
                                    <Edit size={15} />
                                  </span>
                                  <span className="btn2 text-danger" title="Delete" onClick={() => deletePackage(pkg.id)}>
                                    <Trash2 size={15} />
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
 
    </>
  );
}

export default AdminPackages;
